import { BatchingConfig, BatchingMethod } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getBatchingTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as BatchingConfig;
	const isBatchByField = (): AdvancedTourStep[] => {
		if (config.batchingMethod === BatchingMethod.ByRecord) return [];

		return [
			{
				id: 'batching-field',
				selector: '[data-tour="batching-field"]',
				content:
					'Only Visible when set to "Batch By Field": Set The field from the processing data that the task will batch by.',
			},
		];
	};

	return [
		{
			id: 'batching-method',
			selector: '[data-tour="batching-method"]',
			content: 'Required: Set how the task should batch the incoming records.',
		},
		{
			id: 'batch-all',
			selector: '[data-tour="batch-all"]',
			content:
				'Optional: If checked, the batch size field will be hidden, and the batch size will be set to the record count of the incoming data..',
		},
		...isBatchByField(),
		{
			id: 'batch-size',
			selector: '[data-tour="batch-size"]',
			content:
				'Required: Set the number of records or array items that the task should batch together in records. NOTE: this field has access to the expression selector by clicking "ctrl + space" together, you may use preset expressions for this value.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
